import { inject, Injectable } from "@angular/core";
import { StorageService } from "./storage.service";
import { BehaviorSubject } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class BetConfigService {
  storageService = inject(StorageService);
  betConfig$ = new BehaviorSubject<any>(this.storageService.getItem<any>("betConfig"));

  constructor() { }

  updateBetConfig(data: any) {
    let parsedData = data;

    if (typeof data === "string") {
      try {
        parsedData = JSON.parse(data);
      } catch (error) {
        console.error("Invalid JSON string for betConfig:", error);
        return;
      }
    }

    this.storageService.setItem("betConfig", parsedData);
    this.betConfig$.next(parsedData);
  }
}
